import React from 'react';
export { reducer } from './ReportsReducer';

export const ReportsLazy = React.lazy(() => import(/* webpackChunkName: "Reports" */ './ReportsContainer'));

